var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.7636 11C20.7636 12.6683 20.3465 14.2122 19.5123 15.6316C18.6782 17.0509 17.5514 18.1777 16.132 19.0119C14.7127 19.846 13.1688 20.2631 11.5005 20.2631C9.8321 20.2631 8.28824 19.846 6.86888 19.0119C5.44953 18.1777 4.32276 17.0509 3.48858 15.6316C2.6544 14.2122 2.2373 12.6683 2.2373 11C2.2373 9.33161 2.6544 7.78775 3.48858 6.3684C4.32276 4.94904 5.44953 3.82227 6.86888 2.98809C8.28824 2.15391 9.8321 1.73682 11.5005 1.73682C13.1688 1.73682 14.7127 2.15391 16.132 2.98809C17.5514 3.82227 18.6782 4.94904 19.5123 6.3684C20.3465 7.78775 20.7636 9.33161 20.7636 11Z",
    fill: "#0FBC71"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4511 16.0166L17.109 8.88516C17.2296 8.78181 17.2899 8.6397 17.2899 8.45883C17.2899 8.27796 17.2296 8.13584 17.109 8.03249L16.3129 7.14106C16.1923 7.01186 16.0536 6.94727 15.8968 6.94727C15.74 6.94727 15.6013 7.01186 15.4807 7.14106L10.053 12.9548L7.52015 10.2417C7.39953 10.1125 7.26083 10.0479 7.10403 10.0479C6.94723 10.0479 6.80853 10.1125 6.68791 10.2417L5.89186 11.1331C5.77124 11.2365 5.71094 11.3786 5.71094 11.5595C5.71094 11.7403 5.77124 11.8824 5.89186 11.9858L9.65502 16.0166C9.75151 16.1458 9.88418 16.2104 10.053 16.2104C10.2219 16.2104 10.3546 16.1458 10.4511 16.0166Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIcon);
export default __webpack_public_path__ + "static/media/linked-icon.54bf244d45baa322f4717f9e597583a3.svg";
export { ForwardRef as ReactComponent };